/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationCommon } from '../../../../modules/internationalization/intSelectors';
import { ICommonTranslation } from '../../../../modules/internationalization/types';
import { IRootReducer } from '../../../../reducers/rootReducer';
import { Button } from '../../../common';
import { FooterModalStyled, FooterModalTextStyled, FooterModalTitleStyled } from './styled/footerModalStyled';


interface IMobileCashErrorModalConnectedProps {
    translation: ICommonTranslation;
}

export interface IMobileCashErrorModalProps {
    onCloseModal: () => void;
    code: string;
}

type TMobileCashErrorModal = IMobileCashErrorModalProps & IMobileCashErrorModalConnectedProps;

const MobileCashErrorModal = (props: TMobileCashErrorModal) => {
    return (
        <FooterModalStyled
            data-component={'modal-popup'}
            data-name={'mobile-cash-error-modal'}>
            <FooterModalTitleStyled className="mb-3">
                {props.translation.modal.error + '!'}
            </FooterModalTitleStyled>
            <FooterModalTextStyled
                className="mb-5"
            >
                {
                    props.translation.error.codes[props.code]
                    || `${props.translation.error.defaultMessage} (${props.code})`
                }
            </FooterModalTextStyled>
            <Button
                data-modal-attention="close-button"
                kind="medium"
                onClick={props.onCloseModal}
            >
                {props.translation.modal.ok}
            </Button>
        </FooterModalStyled>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IMobileCashErrorModalConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(MobileCashErrorModal);
